

export function getCode(mobile) {
  const url = 'https://subs.xiongmaoboshi.com/code/send'
  const data = {
    key: `+86${mobile}`,
    type: 12,
  }
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        credentials: 'include',
        mode: 'no-cors',
      },
      body: JSON.stringify(data),
    })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        }
        throw new Error()
      })
      .then(res => resolve(res))
      .catch(err => resolve({ data: '获取验证码失败' }))
  })
}

export function login(mobile, smsCode) {
  const url = 'https://subs.xiongmaoboshi.com/ns/qk/account/login-register'
  const data = {
    mobile: `+86${mobile}`,
    smsCode,
  }
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        credentials: 'include',
        mode: 'no-cors',
      },
      body: JSON.stringify(data),
    })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        }
        throw new Error()
      })
      .then(res => resolve(res))
      .catch(err => resolve({ data: '获取验证码失败' }))
  })
}